import { useEffect, useState } from "react";
import api from "../lib/api";
import { Sparkles, TrendingUp, TrendingDown, Minus } from "lucide-react";

const TONE_STYLE = {
  green: "bg-emerald-50 border-emerald-300 text-emerald-800",
  amber: "bg-amber-50 border-amber-300 text-amber-800",
  red: "bg-red-50 border-red-300 text-red-800",
};
const TONE_ICON = { green: "✓", amber: "⏳", red: "⚠" };

export default function ActivityStreakChip() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get("/activities/weekly-streak")
      .then(r => setData(r.data))
      .catch(() => setErr(true));
  }, []);
  if (err || !data) return null;
  const tone = data.tone || "amber";
  const style = TONE_STYLE[tone] || TONE_STYLE.amber;
  const trend = data.trend;
  const office = [data.city, data.destination].filter(Boolean).join(", ");
  return (
    <div className={`inline-flex items-center gap-2 border rounded-full px-3 py-1.5 text-xs font-semibold ${style}`}
         title={`ISO week ${data.week_start} → ${data.week_end}${office ? " · " + office : ""} · Last week: ${data.planned_last_week ?? 0}`}
         data-testid="activity-streak-chip">
      <Sparkles size={13}/>
      <span>{data.planned} of {data.min_required} activities planned this week</span>
      <span className="text-base leading-none">{TONE_ICON[tone]}</span>
      {typeof trend === "number" && (
        <span className="inline-flex items-center gap-0.5 text-[10px] font-medium border-l border-current/40 pl-1.5 ml-0.5" data-testid="streak-trend">
          {trend > 0 ? <TrendingUp size={11}/> : trend < 0 ? <TrendingDown size={11}/> : <Minus size={11}/>}
          {trend > 0 ? "+" : ""}{trend} vs last week
        </span>
      )}
    </div>
  );
}
